import { render } from "./ModalAtendimentosDetalhados.vue?vue&type=template&id=6033b854&scoped=true&ts=true"
import script from "./ModalAtendimentosDetalhados.vue?vue&type=script&lang=ts"
export * from "./ModalAtendimentosDetalhados.vue?vue&type=script&lang=ts"

import "./ModalAtendimentosDetalhados.vue?vue&type=style&index=0&id=6033b854&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6033b854"]])

export default __exports__